import superjson from 'superjson';
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react';
import { type User } from '@/db/types';
import { formatUsername } from '@/utils/format-username';

export const getUsers = async (): Promise<User[]> => {
  const res = await fetch('/api/users');
  return superjson.parse<User[]>(await res.text());
}
export const useUsers = () => {
  return useQuery<User[]>({ queryKey: ['users'], queryFn: getUsers });
}
export const useUser = (name: string) => {
  const usersQuery = useUsers();
  const username = formatUsername(name);
  const user = useMemo<User | undefined>(
    () => usersQuery.data?.find(user => formatUsername(user.name) === username) ?? undefined,
    [usersQuery.data, username]
  );
  return {
    ...usersQuery,
    data: user,
  };
}

export const useLeaderboardGlobal = () => {
  const usersQuery = useUsers();
  const users = useMemo<User[]>(
    () => [...(usersQuery.data ?? [])].sort((a, b) => b.score - a.score),
    [usersQuery.data]
  );

  return {
    ...usersQuery,
    data: users,
  };
}
export const useLeaderboardSession = () => {
  const usersQuery = useUsers();
  const users = useMemo<User[]>(
    () => [...(usersQuery.data ?? [])].sort((a, b) => b.sessionScore - a.sessionScore),
    [usersQuery.data]
  );

  return {
    ...usersQuery,
    data: users,
  };
}

export const getThumbnail = async (name: string) => {
  const username = formatUsername(name);
  let thumbnail = localStorage.getItem(`thumbnail-${username}`);
  if (thumbnail) return thumbnail;

  const res = await fetch(`/api/thumbnail/${username}`);
  const data = JSON.parse(await res.text());
  const url =  data.thumbnail_url;
  localStorage.setItem(`thumbnail-${username}`, url);
  return url;
}
export const useThumbnail = (name: string) => {
  const username = formatUsername(name);
  return useQuery({
    queryKey: ['thumbnail', `thumbnail:${username}`],
    queryFn: () => getThumbnail(username),
  });
}